module.exports = __webpack_public_path__ + "img/CPTemp7.59f46cfe.png";